import app from "flarum/forum/app";

function isSameDayInTimezone(utcTime: string, timezoneOffset: number) {
  // Create a Date object for the given UTC time
  const utcDate = new Date(utcTime);

  // Get the current UTC time
  const currentUtcDate = new Date();

  // Convert the UTC time to the desired timezone by applying the offset (in milliseconds)
  const targetTimezoneOffset = timezoneOffset * 60 * 60 * 1000; // Convert offset from hours to milliseconds
  const targetDate = new Date(utcDate.getTime() + targetTimezoneOffset);
  const currentTargetDate = new Date(currentUtcDate.getTime() + targetTimezoneOffset);

  // Compare the date parts (year, month, day) in the desired timezone
  return (
      targetDate.getUTCFullYear() === currentTargetDate.getUTCFullYear() &&
      targetDate.getUTCMonth() === currentTargetDate.getUTCMonth() &&
      targetDate.getUTCDate() === currentTargetDate.getUTCDate()
  );
}

export function isSigned() {
  const signData: any = app.session.user?.data.attributes?.signData;
  if (!signData) return false;
  return isSameDayInTimezone(signData.lastSign, signData.signOffset);
}
